import React from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { TextWrapper, TextLabel, useStyles } from './ResetPassword.style';
import PrimaryButton from '../../../../components/PrimaryButton/PrimaryButton.component';
import { t } from '../../../../i18n';
import ErrorPopup from 'src/components/ErrorPopup/ErrorPopup';
import API from 'src/api/api';
import { isKeyPressEnterEvent } from 'src/utils/common.util';
import ErrorMessageWithIcon from 'src/components/ErrorMessageWithIcon/ErrorMessageWithIcon.component';
import LoadingContainer from 'src/components/LoadingContainer/LoadingContainer';
import { pathOr } from 'ramda';
import PasswordsWithValidation from '@legwork/react-ui-components/PasswordsWithValidation/PasswordsWithValidation';

interface IProps {
  cookies: {
    userInfo: {
      emailAddress: string;
      name: { nameFirst: string; nameLast: string };
    };
    role: string;
    token: string;
  };
  setResetPasswordSuccessful(a: boolean): void;
}

const SetNewPasswordForm: React.FC<IProps> = ({
  cookies,
  setResetPasswordSuccessful
}) => {
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  
  const [errorMessage, setErrorMessage] = React.useState<string>('');
  const [showErrorPopup, setShowErrorPopup] = React.useState<boolean>(false);

  const handleSubmit = ({
    currentPassword,
    password,
  }: {
    currentPassword?: string;
    password: string;
  }) => {
    API()
      .post('/auth/v1/change-password', {
        currentPassword,
        newPassword: password
      })
      .then((response) => {
        if (response.status !== 204) {
          return;
        }

        setResetPasswordSuccessful(true);
        setIsLoading(false);
      })
      .catch((error) => {
        if (error.response.status) {
          const errorMessageFromAPI = pathOr(error.message, [
            'response',
            'data',
            'message'
          ])(error);

          setIsLoading(false);

          setErrorMessage(errorMessageFromAPI);
          setShowErrorPopup(true);

          return 
        }

        setIsLoading(false);

        setErrorMessage(error.message);
        setShowErrorPopup(true);
      });
  }

  return (
    <LoadingContainer isLoading={isLoading} isOverlay={true}>
      <>
        <PasswordsWithValidation
          onSubmit={handleSubmit}
          existingPassword={true}
          usernameOrEmail={cookies?.userInfo?.emailAddress}
        />

        <ErrorPopup
          showErrorPopup={showErrorPopup}
          setShowErrorPopup={setShowErrorPopup}
          errorMessage={errorMessage}
        />
      </>
    </LoadingContainer>
  );
};

export default SetNewPasswordForm;
